module.exports = __webpack_public_path__ + "cd0e954bd3a2d6a7fae60ba9479835a3.svg";